import { BUTTON_CLASSES } from 'common/vue/Data/Constants/buttonClasses';
export default {
    pcRejectButton: {
        root: {
            class: [BUTTON_CLASSES.BASE, BUTTON_CLASSES.SEVERITY.SECONDARY, 'tw-max-w-fit tw-text-base', 'tw-px-3 tw-py-1.5'],
        },
    },
    pcAcceptButton: {
        root: {
            class: [BUTTON_CLASSES.BASE, BUTTON_CLASSES.SEVERITY.PRIMARY, 'tw-max-w-fit tw-text-base', 'tw-px-3 tw-py-1.5 '],
        },
    },
};
